//ModifiedView

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { postAPI, patchAPI } from "../API/ApiService";
import { BASE_URL } from "../constant/apiUrl";
import {
  libraryToggle,
  removeItemByContentId,
  formatDate,
  toggleFavourite,
  toggleSpotlightFavourtie,
} from "../utils/function";
import {
  setFetchFavourtie,
  setFavourites,
  favouriteSelector,
  setSpecialProject,
} from "../slices/internalPageSlice";
import { showErrorToast } from "../utils/Toast/toast";
import { setLibrary, setLibraryPageDetails } from "../slices/LibraryPageSlice";
import { setSpotlight } from "../slices/spotlightSlice";

const withCommonCardLogic = (WrappedComponent) => {
  return function CommonCardWrapper(props) {
    const { card, item, content, setLoading, slug } = props;

    const item1 = card ? card : item;
    const [isFavourite, setIsFavourite] = useState(
      item1?.favorite || item1?.is_favorite
    );

    const dispatch = useDispatch();
    const location = useLocation();

    const specialRoutes = ["/favorites"];
    const isDynamicSearchRoute = location.pathname.startsWith("/search");
    const isSpecialRoute = specialRoutes.includes(location.pathname);
    const isLibraryRoute = location.pathname === "/library"; // EXACT match
    const isLibraryDetailsRoute =
      location.pathname.startsWith("/library-details");
    const isSpecialProjectsRoute = location.pathname === "/special-projects";
    const isRootRoute = location.pathname === "/"; // ONLY root path
    const { spotlight } = useSelector((store) => store.spotlight);

    const { favourites, pages } = useSelector((store) => store.internalPage);
    const { library, librayDetails } = useSelector(
      (store) => store.libraryDetailPage
    );

    const { specialProject } = useSelector((store) => store.internalPage);

    const navigate = useNavigate();

    const addViewCount = async (contentId, goto, card) => {
      setLoading(true);
      try {
        const response = await patchAPI(`${BASE_URL}/content/${contentId}`, {});
        if (response?.status === 200) {
          const data = { ...card, content: content };
          navigate(goto, { state: data });
        }
      } catch (err) {
        showErrorToast(err.message);
      } finally {
        setLoading(false);
      }
    };

    const handleNavigate = (card, pageName) => {
      const contentId = card?.contentId || card?.id;
      if (pageName === "Link") {
        addViewCount(contentId, `/link/${contentId}`, card);
      } else if (pageName === "Document") {
        addViewCount(contentId, `/document/${contentId}`, card);
      } else if (pageName === "Video") {
        addViewCount(contentId, `/video-details/${contentId}`, card);
      }
    };

    const handleAddFavourite = async (card, contentType) => {
      setLoading(true);
      const contentId = card?.contentId || card?.id;

      try {
        const response = await postAPI(
          `${BASE_URL}/favorites/save?contentId=${contentId}&userId=1&favorite=${!isFavourite}`
        );

        if (response?.status === 200) {
          setIsFavourite(response?.data?.favorite);
          if (isSpecialRoute) {
            const updatedData = removeItemByContentId(
              favourites,
              response?.data?.contentId
            );

            dispatch(setFetchFavourtie(true));

            dispatch(setFavourites(updatedData));
          } else if (isDynamicSearchRoute) {
            dispatch(setFetchFavourtie(true));
          } else if (isLibraryRoute) {
            const result = libraryToggle(
              library,
              contentId,
              content,
              response?.data.favorite
            );

            dispatch(setLibrary(result));
          } else if (isLibraryDetailsRoute) {
            const result = libraryToggle(
              librayDetails,
              contentId,
              content,
              response?.data.favorite
            );
            dispatch(setLibraryPageDetails(result));
          } else if (isSpecialProjectsRoute) {
            const result = toggleFavourite(
              specialProject,
              contentId,
              content,
              response?.data.favorite
            );
            dispatch(setSpecialProject(result));
          } else if (isRootRoute) {
            const result = toggleSpotlightFavourtie(
              spotlight,
              contentId,
              response?.data.favorite
            );
            dispatch(setSpotlight(result));
          } else {
            dispatch(
              favouriteSelector({
                page: pages[slug],
                contentId, // the item toggled
                slug,
                contentType: contentType,
              })
            );
          }
        }
      } finally {
        setLoading(false);
      }
    };

    return (
      <WrappedComponent
        {...props}
        formatDate={formatDate}
        isFavourite={isFavourite}
        handleAddFavourite={(card, contentType) =>
          handleAddFavourite(item1, contentType)
        }
        handleNavigate={(item, pageName) => handleNavigate(item, pageName)}
      />
    );
  };
};

export default withCommonCardLogic;
